import { auth } from '../firebase';


const SignOut = ({ history }) => {
  auth.signOut();
  history.push('/');
  return null;
}

export default SignOut;